import { LandingTemplate } from "@/components/LandingTemplate";

const COVER = "https://static.prod-images.emergentagent.com/jobs/57ee598e-7cea-410b-a94f-0984571bd71d/images/7296781ac8cdf4705c3f647ca749a9dedacdb1fe2d005865a8ceeca87b17ea23.jpeg";

const BOOK_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Book",
  name: "What No One Taught You: The Unspoken Rules of Human Behavior",
  alternateName: "The Observer's Notebook — Vol. 1",
  author: { "@type": "Person", name: "Olamide Ojo" },
  bookFormat: "https://schema.org/EBook",
  numberOfPages: 69,
  inLanguage: "en-GB",
  image: COVER,
  publisher: { "@type": "Organization", name: "Zuntria Limited" },
  offers: {
    "@type": "Offer",
    price: "7.99",
    priceCurrency: "GBP",
    availability: "https://schema.org/InStock",
    url: "https://zuntria.co.uk/book",
  },
};

export default function BookPage() {
  return (
    <LandingTemplate
      testid="book-landing"
      eyebrow="The Observer's Notebook · Vol. 1"
      h1="What No One Taught You — The Unspoken Rules of Human Behavior"
      sub="By Olamide Ojo, founder of Zuntria. 69 pages of sharp, practical observations on the hidden rules that shape every room you walk into — fear, focus, memory, influence and the unspoken dynamics no one teaches you. Instant PDF download."
      cta="Get the eBook — £7.99"
      ctaTo="/marketplace?q=What%20No%20One%20Taught%20You"
      extraSchema={BOOK_SCHEMA}
      bullets={[
        { title: "Read people clearly", text: "Understand the fear, status and memory patterns driving how people around you actually behave." },
        { title: "Observations, not theory", text: "Short, direct chapters written from real observation — no academic padding, just what works." },
        { title: "Built for doers", text: "Written in the same spirit Zuntria is built: see the game clearly, then execute." },
        { title: "Instant download", text: "Buy once, download the full PDF immediately. Read on any phone, tablet or laptop." },
      ]}
      faqs={[
        { q: "Who wrote What No One Taught You?", a: "Olamide Ojo — the London-based founder of Zuntria, the AI success platform for the diaspora hustle. The book is Vol. 1 of his Observer's Notebook series." },
        { q: "What is the book about?", a: "The unspoken rules of human behaviour: how fear drives decisions, how focus and memory shape what people see, and the quiet dynamics of influence in everyday life — distilled into 69 pages of practical observations." },
        { q: "What format is it and how do I get it?", a: "It's a PDF eBook. Buy it on the Zuntria Marketplace for £7.99 and download it instantly after payment — no waiting, no shipping." },
        { q: "Is there a sample I can read first?", a: "The opening observations cover The Architecture of Fear, The Mirror of the Unconscious and The Law of Focus. The full contents are listed on the marketplace listing before you buy." },
      ]}
    >
      <div className="mt-12 grid gap-8 rounded-2xl border border-border bg-card p-6 md:grid-cols-[220px_1fr] md:items-center md:p-8">
        <img src={COVER} alt="What No One Taught You book cover — Olamide Ojo" className="mx-auto w-44 rounded-xl border border-border shadow-2xl md:w-full" data-testid="book-cover-img" />
        <blockquote className="text-sm italic text-muted-foreground md:text-base">
          "Most people are not reacting to you. They are reacting to what you remind them of. Learn the difference,
          and every room becomes easier to read."
          <footer className="mt-3 not-italic text-xs text-muted-foreground">— From Observation 1: The Architecture of Fear</footer>
        </blockquote>
      </div>
    </LandingTemplate>
  );
}
